import { render, staticRenderFns } from "./CustomerImportForm.vue?vue&type=template&id=ffec859a&"
import script from "./CustomerImportForm.vue?vue&type=script&lang=js&"
export * from "./CustomerImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports